'use strict';

/**
 * @name position
 */

exports.getCity = require('./get-city.js');



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/position/index.js
// module id = 119
// module chunks = 0 8 9